import useDrawer from 'hooks/useDrawer/useDrawer';
import useEnqueueSnackbar from 'hooks/useEnqueueSnackbar';
import useInstallers from 'hooks/useInstallers/useInstallers';
import useModal from 'hooks/useModal/useModal';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { EditInstallerDrawer } from 'state/types';
import Button from 'ui/atoms/Button/Button';
import Icon from 'ui/atoms/Icon/Icon';
import Modal from 'ui/atoms/Modal/Modal';
import Typography from 'ui/atoms/Typography/Typography';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

const DeleteInstaller: React.FC<React.PropsWithChildren> = () => {
  const { translation } = useTranslation();
  const { hideModal } = useModal();
  const { hideDrawer } = useDrawer();
  const { drawerState } = useDrawer<EditInstallerDrawer>();
  const enqueueSnackbar = useEnqueueSnackbar();
  const handleFetchError = (errorMessage: string) => enqueueSnackbar(errorMessage, { snackbartype: 'error' });
  const { unsetInstallerById, unsetInstallerByIdMutationLoading } = useInstallers({
    handleFetchError
  });

  const handleDeleteInstaller = () => {
    if (!unsetInstallerByIdMutationLoading) {
      unsetInstallerById(drawerState.contentValue.id);
      hideModal();
      hideDrawer();
    }
  };

  return (
    <Modal>
      <ComponentWrapper
        flexDirection="column"
        width="36rem"
        gap="2rem"
        margin="1rem 0"
        justifyContent="center"
        alignItems="center"
      >
        <Icon name="DeleteBin" color="dTextHigh" width={40} height={40} viewBox="0 0 24 24" id="delete-bin-icon" />
        <ComponentWrapper flexDirection="column" justifyContent="center" alignItems="center">
          <ComponentWrapper flexDirection="column" justifyContent="center" alignItems="center">
            <Typography textAlign="center" variant="title2" color="dTextHigh">
              {translation.are_you_sure_that_you_want_to_delete_this_installer}
            </Typography>
          </ComponentWrapper>
          <ComponentWrapper flexDirection="column" justifyContent="center" alignItems="center">
            <Typography textAlign="center" variant="body3" color="dTextHigh">
              {translation.the_installer_will_no_longer_be_able_to_assign_locks_to_atlas}
            </Typography>
          </ComponentWrapper>
        </ComponentWrapper>
        <ComponentWrapper width="100%">
          <Button backgroundColor="transparent" textColor="b1" onClick={hideModal} id="cancel-button-modal">
            {translation.no_thank_you}
          </Button>
          <Button onClick={handleDeleteInstaller} id="ok-button-modal">
            {translation.yes_i_m_sure}
          </Button>
        </ComponentWrapper>
      </ComponentWrapper>
    </Modal>
  );
};

export default DeleteInstaller;
